import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // {
  //   path: '',
  //   title: 'Dashboard',
  //   loadChildren: () =>
  //     import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  // },
  {
    path: 'new',
    title: 'New Customer',
    loadChildren: () => import('./new-accounts/new-accounts.module').then((m) => m.NewAccountsModule)
  },
  {
    path: 'account',
    title: 'Accounts',
    loadChildren: () => import('./accounts/accounts.module').then((m) => m.AccountSearchModule)
  },
  {
    path: 'support',
    title: 'Support',
    loadChildren: () => import('./support/support.module').then((m) => m.SupportModule)
  },
  {
    path: 'reports',
    title: 'Reports',
    loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule)
  },
  {
    path: 'settings',
    title: 'Settings',
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule)
  },
  //nothing can go below this one
  { path: '**', redirectTo: 'account', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
